import React from 'react';
import { useParams } from 'react-router-dom';
import { WorkspaceAPI } from '../../../redux/stoerkID/StoerkIdAPI.model';
import { NavigationPath } from '../../DeviceManager/navigations/navigationPath';
import { getPolyglot } from '../../../i18n';
import WorkspaceName from './WorkspaceName';

export function useNavigationPath(props: {
  workspace: WorkspaceAPI | undefined;
}): NavigationPath[] {
  const params = useParams<{
    workspaceId: string;
  }>();
  const polyglot = getPolyglot();
  const sectionsNavigation: NavigationPath[] = [
    {
      content: polyglot.t('stoerk_id.customer_list.title'),
      href: '/account/users',
      key: 'list-customers',
    },
    {
      content: <WorkspaceName workspace={props.workspace} />,
      href: `account/id/${params.workspaceId}`,
      key: 'policy-create',
    },
  ];

  return sectionsNavigation;
}
